import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const INTERESTS = ["Investing", "Tokenizing an asset", "Partnership", "Book a demo"];

export default function LeadModal({ open, onOpenChange, defaultInterest }) {
  const [form, setForm] = useState({ name: "", email: "", company: "", interest: "", message: "" });
  const [loading, setLoading] = useState(false);

  const update = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.email.trim()) {
      toast.error("Name and email are required.");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/leads`, { ...form, interest: form.interest || defaultInterest });
      toast.success("Thank you. Our team will be in touch shortly.");
      setForm({ name: "", email: "", company: "", interest: "", message: "" });
      onOpenChange(false);
    } catch {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-auvra-elevated border border-white/10 text-white sm:max-w-md" data-testid="lead-modal">
        <DialogHeader>
          <DialogTitle className="text-2xl font-semibold tracking-tight">Get started with AUVRA</DialogTitle>
          <DialogDescription className="text-secondary-auvra">
            Tell us a little about you and our institutional team will reach out.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4 mt-2" data-testid="lead-form">
          <input data-testid="lead-name" value={form.name} onChange={update("name")} placeholder="Full name *"
            className="w-full bg-black border border-white/15 rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-auvra-blue transition-colors" />
          <input data-testid="lead-email" type="email" value={form.email} onChange={update("email")} placeholder="Work email *"
            className="w-full bg-black border border-white/15 rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-auvra-blue transition-colors" />
          <input data-testid="lead-company" value={form.company} onChange={update("company")} placeholder="Company"
            className="w-full bg-black border border-white/15 rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-auvra-blue transition-colors" />
          <select data-testid="lead-interest" value={form.interest || defaultInterest || ""} onChange={update("interest")}
            className="w-full bg-black border border-white/15 rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-auvra-blue transition-colors text-secondary-auvra">
            <option value="">{"I'm interested in…"}</option>
            {INTERESTS.map((i) => <option key={i} value={i}>{i}</option>)}
          </select>
          <textarea data-testid="lead-message" value={form.message} onChange={update("message")} placeholder="Message (optional)" rows={3}
            className="w-full bg-black border border-white/15 rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-auvra-blue transition-colors resize-none" />
          <button type="submit" disabled={loading} data-testid="lead-submit"
            className="w-full bg-auvra-blue hover:bg-auvra-blue/90 disabled:opacity-60 text-white font-medium py-3.5 rounded-full transition-all hover:shadow-[0_0_30px_rgba(37,99,235,0.5)]">
            {loading ? "Submitting…" : "Request Access"}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
